export const COUPON_CONSTANTS = {
    SMALL_DEVICE_SNAP_POINTS: ['90%', '90%'],
    REGULAR_DEVICE_SNAP_POINTS: ['78%', '78%'],
    DEFAULT_VARIANT: 'default',
} as const;
